import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environment/environment';

@Injectable({
    providedIn: 'root'
})
export class RetailScanningService {

    baseUrl = environment.baseUrl;

    constructor(private httpService: HttpClient) { }

    getScanResult(data: any) {
        return this.httpService.post(`${this.baseUrl}checkRetailQrCode`, data);
    }

}
